
import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './reports-wizard-footer.hbs'
import i18n from 'scoreboard/components/i18n'
import WizardProgress from 'scoreboard/components/wizard-progress'

var Footer = Backbone.View.extend({

	//this.model is the wizard-info model

	tagName: 'footer',

	className: 'dialog-footer',

	events: {
		'click .back': 'back',
		'click .button-primary' : 'next'
	},

	initialize: function() {
		//re-render when the step changes, recheck confirm when model changes
		this.listenTo(this.model, {
			'change:index': this.render,
			'path:changed': this.render,
			'path-model:changed': this.render
		})
	},

	render: function() {
		if (this.$el.children().length == 0) {
			this.$el.html(template())
		}

		var progress = this.model.progress()
		this._renderConfirm(progress)
		this._renderProgress(progress)
		return this
	},

	//render confirm based on wizard state on model validity
	_renderConfirm: function(p) {
		var defaultConfirm = p.remaining == 0 ? 'common.finish' : 'common.next'

		var step = this.model.currentStep()
		//support method or function passing the remaining number of steps
		var cc = _.isFunction(step.confirmCode) ?
			step.confirmCode(p, this.model.attributes) : step.confirmCode
		var confirmText = cc || defaultConfirm

		this.$('.button-primary')
			.prop('disabled', !this.model.isValid())
			.text(i18n.get(confirmText))
	},

	_renderProgress: function(p) {
		let values = {
			step: this.model.get('index') + 1,
			steps: p.visible,
			lastNavigable: p.completed + (p.visible == p.completed ? 0 : 1)
		}
		//#16073 prevent setting of duplicate values from screwing up animations
		if (this.step == values.step &&
			this.steps == values.steps &&
			this.lastNavigable == values.lastNavigable) {
			return
		}
		_.assign(this, values)

		// If we already have a wizard progress displaying, manipulate it to
		// reflect the current progress
		if (this.wizardProgress) {
			this.wizardProgress.setValues(values)
		// If we don't have a wizard progress already, and we have more than 1
		// step to display, create and insert one.
		} else if (p.visible > 1) {
			this.wizardProgress = new WizardProgress(values)

			this.$('.wizard-progress-container').html(this.wizardProgress.el)
			this.wizardProgress.render()
			this.wizardProgress.on('jump', this.jump.bind(this))
		}

		this.$('.back').toggleClass('is-not-displayed', this.model.get('index') == 0)
	},

	jump: function(step) {
		var current = this.model.get('index')
		this.model.transition((step - 1) - current)
	},

	back: function(e) {
		this.model.transition(-1)
	},

	next: function() {
		var step = this.model.currentStep()
		//apply any server validation before proceeding
		var validate = step.serverValidate || _.noop
		$.when(validate(this.model.currentModel()))
		 .always(function() {
		 	if (this.model.isValid()) {
		 		this.model.transition()
		 	}
		 }.bind(this))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.wizardProgress], 'remove')
	}

})

export default Footer

Footer.__filename__ = 'reports/wizard/reports-wizard-footer.js'
